import { MenuIcon } from '@/components/icons'
import { ProfileMenu } from '@/components/profile-menu'
import { ROUTE_LOGIN, ROUTE_SIGNUP } from '@/constants/Routes'
import { useAppSelector } from '@/hooks/useRedux'
import { authSelector } from '@/pages/auth/selectors'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

type Props = {
  onDrawerToggle: () => void
  toggleShowProfileMenu: () => void
}

export const MobileHeader = ({ onDrawerToggle, toggleShowProfileMenu }: Props) => {
  const { t } = useTranslation()

  const { token } = useAppSelector(authSelector)

  return (
    <div className="bg-white flex md:hidden px-4 py-8 justify-between">
      <div className="flex items-center">
        <button onClick={onDrawerToggle}>
          <MenuIcon />
        </button>
        <img src="/img/dupr_dark.svg" alt="Dreamland Universal Pickleball Ratings" className="w-20 h-6 ml-4" />
      </div>
      {!token && (
        <div className="flex items-center">
          <Link
            to={ROUTE_LOGIN}
            className="mx-4 py-1 px-3 border-primary-700 border rounded text-primary-700 font-semibold"
          >
            {t('common.LogIn')}
          </Link>
          <Link to={ROUTE_SIGNUP} className="py-1 px-3 rounded bg-azul font-semibold text-white border border-azul">
            {t('common.SignUp')}
          </Link>
        </div>
      )}
      {token && (
        <ProfileMenu
          imgClass="w-10 h-10"
          toggleShowProfileMenu={toggleShowProfileMenu}
          toggleShowDropdown={toggleShowProfileMenu}
        />
      )}
    </div>
  )
}
